import moment from 'moment-timezone';

export default function formatDateWithoutTime(value, dateFormat) {
  if (value != null) {
    const date = moment(new Date(value));
    return date.format(dateFormat != null ? dateFormat : 'LL');
  }
}
